import Cookies from 'js-cookie'

const TokenKey = 'Customer-Admin-Token'

const LongSessionKey = 'Customer-Long-Session'

export function getToken() {
  return Cookies.get(TokenKey)
}

export function setToken(token) {
  return Cookies.set(TokenKey, token)
}

export function removeToken() {
  return Cookies.remove(TokenKey)
}

export function getLongSession() {
  return Cookies.get(LongSessionKey)
}

export function setLongSession(token) {
  return Cookies.set(LongSessionKey, token)
}

export function removeLongSession() {
  return Cookies.remove(LongSessionKey)
}
